export default __webpack_public_path__ + "static/media/banner-png.1b989969.png";